module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('main', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/logo-login.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.loginGoogle($event)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "src": require("../assets/google-icon.png")
    }
  }), _vm._v("\n      Login Gmail Flux\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12a88707"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 368
// module chunks = 1